import * as type from './mutation-types'
export const state = {
    status: -9999,
    errmsg: '',

    msgNo: {},
    categoryList: {},
    faqContentList: {},
    faqContentInfo: {},
    faqQuStatus: {},
    msgTextStatus: {},
    msgAttrStatus: {},
    FaqHstQuList: {},
    FaqHstMsg: {},
    faqEvalStatus: {},
    unknownStatus: {},
    searchData: {},
    reportStatus: {},
    upmsgStatus: {},
    faqVersion: {},

    loadingNO: '',
    loadingCate: '',
    loadingFC: '',
    loadingInfo: '',
    statusQu: '',
    statusText: '',
    statusAttr: '',
    loadingHst: '',
    loadingHM: '',
    statusEval: '',
    statusUnknown: '',
    reporting: '',
    searching: '',
    updatingms: '',
    fvLoading: '',

}
export const mutations = {
    [type.ERROR_RECEIVE](state, res) {},
    [type.GETNEWMSGNO_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.msgNo = {}
        state.loadingNO = 'loadingNo'
    },
    [type.GETNEWMSGNO_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.msgNo = (res && res.content) || {}
        state.loadingNO = state.status > -9999 && 'loadedNo'
    },

    [type.GETCATEGORYLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.categoryList = {}
        state.loadingCate = 'loadingCate'
    },
    [type.GETCATEGORYLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.categoryList = (res && res.content) || {}
        state.loadingCate = state.status > -9999 && 'loadedCate'
    },

    [type.GETFAQCONTENTLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.faqContentList = {}
        state.loadingFC = 'loadingFC'
            // console.log(state.loadingFC)
    },
    [type.GETFAQCONTENTLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.faqContentList = (res && res.content) || {}
        state.loadingFC = state.status > -9999 && 'loadedFC'
            // console.log(state.loadingFC)
    },

    [type.GETFAQCONTENTINFO_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.faqContentInfo = {}
        state.loadingInfo = 'loadingInfo'
    },
    [type.GETFAQCONTENTINFO_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.faqContentInfo = (res && res.content) || {}
        state.loadingInfo = state.status > -9999 && 'loadedInfo'
    },

    [type.SUBMITQUESTION_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.faqQuStatus = {}
        state.statusQu = 'statingQu'
    },
    [type.SUBMITQUESTION_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.faqQuStatus = (res && res.content) || {}
        state.statusQu = state.status > -9999 && 'statedQu'
    },

    [type.SUBMITQUMSGTEXT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.msgTextStatus = {}
        state.statusText = 'statingText'
    },
    [type.SUBMITQUMSGTEXT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.msgTextStatus = (res && res.content) || {}
        state.statusText = state.status > -9999 && 'statedText'
            // console.log(state)
    },

    [type.SUBMITQUMSGATTR_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.msgAttrStatus = {}
        state.statusAttr = 'statingAttr'
    },
    [type.SUBMITQUMSGATTR_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.msgAttrStatus = (res && res.content) || {}
        state.statusAttr = state.status > -9999 && 'statedAttr'
    },

    [type.GETHSTQULIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.loadingHst = 'loadingHst'
    },
    [type.GETHSTQULIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.FaqHstQuList = (res && res.content) || {}
        state.loadingHst = state.status > -9999 && 'loadedHst'
    },

    [type.GETHSTQUMSGLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.FaqHstMsg = {}
        state.loadingHM = 'loadingHM'
    },
    [type.GETHSTQUMSGLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.FaqHstMsg = (res && res.content) || {}
        state.loadingHM = state.status > -9999 && 'loadedHM'
    },

    [type.SUBMITEVALUATE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.faqEvalStatus = {}
        state.statusEval = 'statingEval'
    },
    [type.SUBMITEVALUATE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.faqEvalStatus = (res && res.content) || {}
        state.statusEval = state.status > -9999 && 'statedEval'
    },

    [type.SAVEUNKNOWNQU_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.unknownStatus = {}
        state.statusUnknown = 'statingUnknown'
    },
    [type.SAVEUNKNOWNQU_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.unknownStatus = (res && res.content) || {}
        state.statusUnknown = state.status > -9999 && 'statedUnknown'
    },

    [type.SEARCHFAQ_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.searchData = {}
        state.searching = 'searching'
    },
    [type.SEARCHFAQ_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.searchData = (res && res.content) || {}
        state.searching = state.status > -9999 && 'searched'
    },

    [type.REPORT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.reportStatus = {}
        state.reporting = 'reporting'
    },
    [type.REPORT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.reportStatus = (res && res.content) || {}
        state.reporting = state.status > -9999 && 'reported'
    },

    [type.UPDATEMSGSTATUS_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.upmsgStatus = {}
        state.updatingms = 'updatingms'
    },
    [type.UPDATEMSGSTATUS_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.upmsgStatus = (res && res.content) || {}
        state.updatingms = state.status > -9999 && 'updatedms'
    },

    [type.GETFAQVERSION_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.faqVersion = {}
        state.fvLoading = 'loading'
    },
    [type.GETFAQVERSION_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.faqVersion = (res && res.content) || {}
        state.fvLoading = state.status > -9999 && 'loaded'
    }
}